<template>
    <div class="flex flex-col gap-2">
        <div class="relative sm:flex items-center">
            <label :for="inputId" class="block font-bold my-2 sm:absolute sm:-left-40 sm:w-36 sm:text-right">
                {{ props.name }}
            </label>
            <input
                :id="inputId"
                v-model.trim="model"
                type="text"
                class="grow w-full"
                :placeholder="props.placeholder"
                :aria-required="!!props.required"
                :aria-invalid="!!props.error"
                :aria-errormessage="messageId"
                @blur="emit('blur')" />
        </div>
        <div v-if="props.error" :id="messageId" class="text-danger text-sm">{{ props.error }}</div>
    </div>
</template>
<script setup lang="ts">
const emit = defineEmits(["blur"]);
const props = defineProps<{ name: string; placeholder: string; required?: boolean; error?: string }>();
const model = defineModel<string>();

const inputId = useId();
const messageId = useId();
</script>
